export default __webpack_public_path__ + "static/media/Bars.aa3c9daa.svg";